import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tln-javelo-logo',
  templateUrl: './javelo-logo.component.html',
  styleUrls: ['./javelo-logo.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class JaveloLogoComponent {}
